
import React, { useEffect, useMemo, useState } from 'react'
import { useSession } from 'src/sdk/session'
import { useProductsQuery } from 'src/sdk/product/useProductsQuery'
import { useInView } from 'react-intersection-observer'
import InsiderBuyTogetherDefaultProductCard from './InsiderBuyTogetherDefaultProductCard'
import '../styles.scss'
import InsiderBuyTogetherLoading from '../InsiderBuyTogetherLoading'

type Props = {
  collectionId: string
  defaultSelected?: boolean
}

export default function InsiderBuyTogetherDefaultShelf({
  collectionId,
  defaultSelected = false,
}: Props) {
  const { ref } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  })

  const { channel } = useSession()

  if (!channel) {
    throw new Error(`InsiderBuyTogetherDefaultShelf: missing channel`)
  }

  const itemsToShow = 2
  const [isShelfLoading, setIsShelfLoading] = useState(true)

  const productList = useProductsQuery({
    first: itemsToShow,
    after: '',
    sort: 'score_desc',
    term: '',
    selectedFacets: [
      { key: 'productClusterIds', value: collectionId },
      { key: 'channel', value: channel },
    ],
  })

  const products = useMemo(
    () => productList?.edges?.map((edge) => edge.node) ?? [],
    [productList]
  )

  useEffect(() => {
    if (productList !== undefined) {
      setIsShelfLoading(false)
    }
  }, [productList])

  if(!isShelfLoading && !products?.length){
    return null
  }

  if (isShelfLoading) {
    return (
      <section className="insider-shelf-default-buytogether">
        <div className="shelf-grid-bt" ref={ref}>
          {Array.from({ length: itemsToShow }).map((_, idx) => (
            <InsiderBuyTogetherLoading key={idx} />
          ))}
        </div>
      </section>
    )
  }

  const visibleProducts = products.slice(0, itemsToShow)

  return (
    <section className="insider-shelf-default-buytogether">
      <div className="insider-shelf-products-bt" ref={ref}>
        {visibleProducts.map((product, idx) => (
          <InsiderBuyTogetherDefaultProductCard
            key={product.id}
            product={product}
            index={idx}
            defaultSelected={defaultSelected}
          />
        ))}
      </div>
    </section>
  )
}
